import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useState } from 'react';
const BottomSheetContainerContext = /*#__PURE__*/ createContext({
    container: null,
    setContainer: ()=>{}
});
export function BottomSheetContainerProvider(param) {
    let { children } = param;
    const [container, setContainerState] = useState(null);
    const setContainer = useCallback((el)=>{
        setContainerState(el);
    }, []);
    const value = React.useMemo(()=>({
            container,
            setContainer
        }), [
        container,
        setContainer
    ]);
    return /*#__PURE__*/ _jsx(BottomSheetContainerContext.Provider, {
        value: value,
        children: children
    });
}
export function useBottomSheetContainer() {
    return useContext(BottomSheetContainerContext);
}
